/**
 * ImageGalleryHeader Component
 *
 * Header bar for the ImageGallery with back button and image title.
 */

import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { ArrowLeftIcon } from '../../icons';
import { colors, spacing, typography } from '../../tokens';

export interface ImageGalleryHeaderProps {
  title?: string;
  onBack?: () => void;
  testID?: string;
}

export const ImageGalleryHeader: React.FC<ImageGalleryHeaderProps> = ({
  title,
  onBack,
  testID,
}) => {
  return (
    <View style={styles.container} testID={testID}>
      {onBack && (
        <Pressable
          onPress={onBack}
          style={styles.backButton}
          hitSlop={8}
          accessibilityRole="button"
          accessibilityLabel="Go back"
        >
          <ArrowLeftIcon size={24} color={colors.brand.white} />
        </Pressable>
      )}
      {title ? (
        <Text style={styles.title} numberOfLines={1} ellipsizeMode="middle">
          {title}
        </Text>
      ) : null}
    </View>
  );
};

ImageGalleryHeader.displayName = 'ImageGalleryHeader';

const HEADER_HEIGHT = 56;

const styles = StyleSheet.create({
  container: {
    height: HEADER_HEIGHT,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: spacing.lg,
    gap: spacing.md,
  },
  backButton: {
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    ...typography.body.mediumEmphasised,
    color: colors.brand.white,
    flex: 1,
  },
});
